import { get } from '@/utils/request/mAxios';
import { DocsContentBody, DocsListBody } from '../types';

const APIs = {
  getPlatConfig: '/gateway/api/doc/client/platform/info/get/',
  getDocsList: '/gateway/api/doc/client/platform/tree/get/',
  getDocsContent: '/gateway/api/doc/client/node/get/',
};

export function getDocsList(params: DocsListBody) {
  return get(APIs.getDocsList, params);
}

export function getDocsContent(params: DocsContentBody) {
  return get(APIs.getDocsContent, params);
}

export function getPlatConfig(params: DocsListBody) {
  return get(APIs.getPlatConfig, params);
}
